import React from 'react';

interface Props {
    children: React.ReactNode;
    resetKey?: string;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        // eslint-disable-next-line no-console
        console.error('Caught by ErrorBoundary:', error, info);
    }

    componentDidUpdate(prevProps: Props) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                    <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
                    <h3 style={{ marginBottom: 8, color: '#1a1a2e' }}>Something went wrong</h3>
                    <p style={{ color: '#888', marginBottom: 20 }}>
                        This page ran into an error. Try reloading, or go back and try again.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            background: '#f00d69',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            padding: '10px 24px',
                            fontSize: 14,
                            fontWeight: 700,
                            cursor: 'pointer',
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;